
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../state';
import { getResource, putResource } from '../../../client/resource';
import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import { Job } from '../../../../../common/framework/model/Job';
import SwitchField from '../../../../framework/fields/SwitchField.vue';
import TextAreaField from '../../../fields/TextAreaField.vue';
import DateTimeField from '../../../fields/DateTimeField.vue';
import PhoneField from '../../../fields/PhoneField.vue';
import EmailField from '../../../fields/EmailField.vue';
import UserGroups from '../users/UserGroups.vue';

@Component({
    components: {
        SwitchField,
        SelectField,
        PhoneField,
        TextField,
        EmailField,
        UserGroups,
        TextAreaField,
        DateTimeField,
        ValidationObserver,
    },
})
export default class EditJob extends Vue {
    // Constants
    readonly resourceType = 'job';

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as Job,
    };

    // Functions
    async mounted() {
        this.local.row = (await getResource<Job>(this.resourceType, this.id))!!;
    }

    async save() {
        await putResource(this.resourceType, this.id, this.local.row);
        this.back();
    }

    async correct() {
        this.$router.push(this.local.row.correctiveActionUrl!!);
    }

    back() {
        this.$router.go(-1);
    }
}
